import { gql } from '@apollo/client';

/** Returns the readiness report as a CSV string. */
export const GET_PAY_RUN_READINESS = gql`
  query GetPayRunReadyness(
    $tenantId: String!
    $startDate: String
    $endDate: String
  ) {
    getPayRunReadyness(
      tenantId: $tenantId
      startDate: $startDate
      endDate: $endDate
    )
  }
`;

export const GET_PAY_RUN_CYCLE_LOGS = gql`
  query GetPayRunCycleLogs(
    $tenantId: String!
    $periodStartISO: String!
    $periodEndISO: String!
    $status: PayRunCycleLogStatus
  ) {
    getPayRunCycleLogs(
      tenantId: $tenantId
      periodStartISO: $periodStartISO
      periodEndISO: $periodEndISO
      status: $status
    ) {
      id
      status
      createdAt
      periodStartISO
      periodEndISO
      periodLengthInDays
      payRunDateFromISO
      payRunDateToISO
      payRunCount
      clientBillIds
      totalPayableAmountCents
      totalClientBillableAmountCents
      errorSummary
      autoFixedItemsSummary
      fileUrl
      fileKey
      payrollSyncReportKey
      payrollSyncReportUrl
      externalReferences
      payRuns {
        id
        userId
        payRunStatus
        payableAmountCents
        totalHours
        payRunDateFromISO
        payRunDateToISO
        payRunPerformedAt
        user {
          id
          firstName
          lastName
          email
        }
        client {
          id
          name
        }
        payRunItems {
          daySequenceId
          jobId
          clientId
          classificationId
          classificationLevelId
          hoursWorked
          totalPayableAmountInCents
          clientBillableAmountInCents
          job {
            id
            title
          }
        }
      }
    }
  }
`;

/**
 * Cycle log detail. Pay run items include their day sequence, job
 * classification and client so the detail view needs no per-id lookups.
 */
export const GET_PAY_RUN_CYCLE_LOG = gql`
  query GetPayRunCycleLog($id: String!) {
    getPayRunCycleLog(id: $id) {
      id
      status
      createdAt
      periodStartISO
      periodEndISO
      periodLengthInDays
      payRunDateFromISO
      payRunDateToISO
      payRunCount
      clientBillIds
      totalPayableAmountCents
      totalClientBillableAmountCents
      errorSummary
      autoFixedItemsSummary
      fileUrl
      fileKey
      payrollSyncReportKey
      payrollSyncReportUrl
      externalReferences
      payRuns {
        id
        userId
        payRunStatus
        payableAmountCents
        totalHours
        payRunDateFromISO
        payRunDateToISO
        payRunPerformedAt
        user {
          id
          firstName
          lastName
          email
        }
        client {
          id
          name
        }
        payRunItems {
          dateISO
          checkInTime
          checkOutTime
          daySequenceId
          jobId
          clientId
          classificationId
          classificationLevelId
          hoursWorked
          totalPayableAmountInCents
          clientBillableAmountInCents
          job {
            id
            title
            classification {
              id
              name
            }
          }
          client {
            id
            name
          }
        }
      }
    }
  }
`;

export const GET_CLIENT_PERIOD_BILL = gql`
  query GetClientPeriodBill($id: String!) {
    getClientPeriodBill(id: $id) {
      id
      clientId
      periodStartISO
      periodEndISO
      totalBillableCents
      status
      errorSummary
      paidAt
      invoiceUrl
      invoiceId
    }
  }
`;

export const INITIATE_PAY_RUN_FOR_TENANT = gql`
  mutation InitiatePayRunForTenant(
    $tenantId: String!
    $periodStartISO: String
    $periodEndISO: String
    $shouldSave: Boolean
    $allOrNothingMode: Boolean
    $attemptToFixErrors: Boolean
  ) {
    initiatePayRunForTenant(
      tenantId: $tenantId
      periodStartISO: $periodStartISO
      periodEndISO: $periodEndISO
      shouldSave: $shouldSave
      allOrNothingMode: $allOrNothingMode
      attemptToFixErrors: $attemptToFixErrors
    ) {
      id
      status
    }
  }
`;

export const FORCE_SYNC_PAY_RUN_CYCLE_LOG = gql`
  mutation ForceSyncPayRunCycleLog($id: String!) {
    forceSyncPayRunCycleLog(id: $id)
  }
`;
